import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const userService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/user/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching user list", error);
            throw error;
        }
    },

    async findById(userId: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/user/findById/${userId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById user", error);
            throw error;
        }
    },

    async save(user: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/user/save`,
                user
            );
            return response.data;
        } catch (error) {
            console.error("Error save user", error);
            throw error;
        }
    },

    async deleteById(userId: number): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/user/deleteById/${userId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById user", error);
            throw error;
        }
    },

    async getAllManagers(): Promise<any> {
        try {
            const response = await apiClient.get<any>(
                `${BASE_URL}/api/v1/user/allManagers`
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching managers", error);
            throw error;
        }
    },

    async uploadUsersCsv(formData: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/user/upload-users-csv`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error save student", error);
            throw error;
        }
    },
}

export default userService;